import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { ButtonComponent } from '../../components/buttons/button/button.component';
import { ErrorCardComponent } from '../../components/card/error-card/error-card.component';
import { InputComponent } from '../../components/inputs/input/input.component';
import { AuthService, LoadingService, ToastService } from '../../services';
import { mustMatchValidator } from '../../validators/must-match/must-match';

@Component({
    selector: 'lib-new-password-form',
    imports: [CommonModule, ReactiveFormsModule, ErrorCardComponent, InputComponent, ButtonComponent],
    templateUrl: './new-password-form.component.html',
    styleUrl: './new-password-form.component.css'
})
export class NewPasswordFormComponent {
    /* eslint-disable */
    @Output() onSuccess = new EventEmitter();
    @Output() onFail = new EventEmitter();

    newPwForm!: FormGroup;

    errors: any = null;

    submitAttempt: boolean = false;

    constructor(
        private fb: FormBuilder,
        private authService: AuthService,
        private loadingService: LoadingService,
        private toastService: ToastService
    ) {
        this.newPwForm = this.fb.group({
            password: [
                '',
                [Validators.required, Validators.minLength(6), mustMatchValidator('password_confirmation', true)]
            ],
            password_confirmation: ['', [Validators.required, Validators.minLength(6), mustMatchValidator('password')]]
        });
    }

    logForm() {
        console.log(this.newPwForm);
        this.submitAttempt = true;
    }

    onBlur() {
        console.log(this.newPwForm);
    }

    submitRequest() {
        const email = this.authService.getForgotPasswordEmail();
        const code = this.authService.getForgotPasswordCode();

        if (!this.newPwForm.valid || !email || !code) {
            this.toastService.errorToast({
                message: 'There was an issue with submitting your request. Please resend your otp code and try again.'
            });
            return;
        }

        this.errors = null;

        this.loadingService.presentLoading();

        this.authService
            .newPassword({
                email: email,
                code: code,
                password: this.newPwForm.value.password,
                password_confirmation: this.newPwForm.value.password_confirmation
            })
            .subscribe({
                next: data => {
                    this.loadingService.dismissLoading();
                    if (data.success) {
                        this.toastService.successToast({
                            message: 'Password successfully reset.'
                        });
                        this.newPwForm.reset();
                        this.onSuccess.emit();
                    } else {
                        this.errors = data.error;
                        this.onFail.emit();
                    }
                },
                error: error => {
                    this.loadingService.dismissLoading();
                    this.errors = error;
                    this.onFail.emit();
                }
            });
    }
}
